function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.9824 16.906C14.4235 16.906 16.4094 14.9353 16.4094 12.5131V4.42676C16.4094 1.98193 14.4275 0 11.9824 0C9.5376 0 7.55566 1.98193 7.55566 4.42676V12.4792C7.55838 14.9228 9.53885 16.9033 11.9824 16.906Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2854 11.6731C17.9895 11.6731 17.7497 11.9131 17.7497 12.2088V12.8222C17.7497 16.0078 15.1673 18.5901 11.9817 18.5901C8.79632 18.5901 6.21401 16.0078 6.21401 12.8222V12.2088C6.21401 11.9131 5.97419 11.6731 5.67829 11.6731C5.38239 11.6731 5.14258 11.9131 5.14258 12.2088V12.8222C5.14258 16.4131 7.92432 19.3665 11.446 19.6406V22.9285H10.4164C10.1205 22.9285 9.88072 23.1684 9.88072 23.4643C9.88072 23.7602 10.1205 24 10.4164 24H13.5472C13.8431 24 14.0829 23.7602 14.0829 23.4643C14.0829 23.1684 13.8431 22.9285 13.5472 22.9285H12.5174V19.6406C16.0393 19.3665 18.8211 16.4131 18.8211 12.8222V12.2088C18.8211 11.9131 18.5813 11.6731 18.2854 11.6731Z",
  fill: "currentColor"
}));

var SvgMicrophone = function SvgMicrophone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrophone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microphone.6d032eaa.svg";
export { ForwardRef as ReactComponent };